<div class="accordian-tab card-header title-space spear-table-header-background">
  <h6 class="m-0">Quick Links</h6>
  <div>
    <button class="btn">
      <em (click)="quickLinkToggle = !quickLinkToggle" class="fa fa-sort-desc"
        [ngClass]="quickLinkToggle ? '' : 'antirotate'"></em>
    </button>
  </div>
</div>
<div [ngClass]="quickLinkToggle ? 'collapsecard' : 'expandcard'">
  <div class="card border-0 card-scrollbar bg-transparent">
    <div class="card-body p-3 text-black-contrast">
      <ul>
        <ng-container *ngFor="let link of links">
          <li><a [href]="link.link">{{link.name}}</a></li>
        </ng-container>

      </ul>
    </div>
  </div>
</div>
